import { useContext } from 'react'
import { bool, array, string } from 'prop-types'
import { utils } from '@digital-commerce/shared-utils'
import localeContext from '../../../../contexts/Locale'
import { formatCurrency } from '../../../../utils/currency'
import NameAndPrice from '../../../atoms/ItemDetails/NameAndPrice/NameAndPrice'

const {
  cart: { getMonthlyItemPrice, getDisplayName, getItemOneTimePrice }
} = utils

const ItemsPrice = ({ items, isRecurring, isFirstMonthPaymentOnly, useDisplayNameOverride }) => {
  const { lang } = useContext(localeContext)

  const renderItemPrice = (item) => {
    const name = useDisplayNameOverride ?? getDisplayName(item)

    const price =
      isRecurring || isFirstMonthPaymentOnly
        ? formatCurrency(getMonthlyItemPrice(item)?.amount, lang)
        : formatCurrency(getItemOneTimePrice(item)?.amount, lang)

    const after = isRecurring && !isFirstMonthPaymentOnly ? '/mo.' : ''

    return <NameAndPrice name={name} price={price} after={after} id={item.id} key={item.id} />
  }

  return <>{items.map(renderItemPrice)}</>
}

export default ItemsPrice

ItemsPrice.propTypes = {
  items: array.isRequired,
  isRecurring: bool,
  isFirstMonthPaymentOnly: bool,
  useDisplayNameOverride: string
}

ItemsPrice.defaultProps = {
  isRecurring: false,
  isFirstMonthPaymentOnly: false,
  useDisplayNameOverride: undefined
}
